import PendoIcon from '../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoActionCard',
  components: {
    PendoIcon
  },
  props: {
    orientation: {
      type: String,
      default: 'vertical',
      validator: orientation => ['vertical', 'horizontal'].includes(orientation)
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [String, Number],
      default: '32'
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: String,
      default: 'never',
      validator: shadow => ['always', 'hover', 'never'].includes(shadow)
    }
  },
  computed: {
    shadowType() {
      return this.disabled ? 'never' : this.shadow;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-action-card.vue2.js.map
